<template>
  <div class="about-us-view min-h-screen overflow-x-hidden">
    <!-- Hero Section -->
    <AboutHeroSection />

    <!-- Main Goal Section -->
    <MainGoalSection />

    <!-- Company Timeline Section -->
    <CompanyTimelineSection />

    <!-- Vision & Mission Section -->
    <VisionMissionSection />

    <!-- Solution-Focused Section -->
    <SolutionFocusedSection />

    <!-- MAGIC Features Section -->
    <MagicFeaturesSection />

    <!-- CTA Section -->
    <AboutCTASection />
  </div>
</template>

<script setup lang="ts">
import AboutCTASection from '@/components/sections/about/AboutCTASection.vue'
import AboutHeroSection from '@/components/sections/about/AboutHeroSection.vue'
import CompanyTimelineSection from '@/components/sections/about/CompanyTimelineSection.vue'
import MagicFeaturesSection from '@/components/sections/about/MagicFeaturesSection.vue'
import MainGoalSection from '@/components/sections/about/MainGoalSection.vue'
import SolutionFocusedSection from '@/components/sections/about/SolutionFocusedSection.vue'
import VisionMissionSection from '@/components/sections/about/VisionMissionSection.vue'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { onMounted } from 'vue'

onMounted(() => {
  AOS.init({
    duration: 1000,
    once: true,
    easing: 'ease-out-cubic',
  })
})
</script>
